export default {
  'user.title': 'Konto',
  'user.persona': 'Angaben zur Person',
  'user.name': 'Name',
  'user.birthday': 'Geburtsdatum',
  'user.password': 'Passwort',
  'user.password.description': 'Passwort ändern',
  'user.email': 'E-Mail',
  'user.phone': 'Telefonnummer',
  'user.contact': 'Kontakt',
  'user.delete-account': 'Konto löschen',

  'user.verification': 'E-Mail Bestätigung',
  'user.verified': 'E-Mail wurde bestätigt',
  'user.not-verified':
    'E-Mail Bestätigung ausstehend. Klicken Sie hier, um die E-Mail erneut zu senden.',
  'user.not-verified.resent':
    'Verifizierungs E-Mail wurde versendet. Erneute E-Mail Zustellung ist nicht mehr möglich.',

  'change-password': 'Passwort ändern',
  'change-password.success': 'Passwort wurde erfolgreich geändert',
  'change-password.success.description': 'Bitte melden Sie sich erneut an',
  'change-password.old-password': 'Altes Passwort',
  'change-password.new-password': 'Neues Passwort',
  'change-password.new-password.repeat': 'Neues Passwort wiederholen',
  'change-password.required-field': 'Bitte füllen Sie alle angegebenen Felder aus',

  'account-details': 'Kontoinformationen',

  'set-new-password': 'Neues Passwort setzen',
  'set-new-password.description': 'Bitte geben Sie Ihr neues Passwort zweimal ein.',

  // Reset password
  'reset-password.sent': 'Bitte überprüfen Sie Ihr Postfach',
  'reset-password.success': 'Passwort wurde zurückgesetzt',
  'reset-password.sent.description':
    'Falls bereits ein Account mit der eingegebenen E-Mail-Adresse existiert, wird Ihnen ein Link zum Zurücksetzen des Passworts an diese Adresse geschickt.',
  'reset-password': 'Passwort zurücksetzen',
  'reset-password.error':
    'Ihr Passwort konnte nicht zurückgesetzt werden. Bitte überprüfen Sie die eingegebene E-Mail Adresse.',
  'prepare-password-reset.title': 'Passwort zurücksetzen',
  'prepare-password-reset.error':
    'Ihr Passwort konnte nicht zurückgesetzt werden. Bitte überprüfen Sie die eingegebene E-Mail Adresse.',
  'prepare-password-reset.description':
    'Bitte geben Sie die E-Mail Adresse an, mit der Sie das Konto erstellt haben. Sie werden eine E-Mail mit einem Link zum Zurücksetzen bekommen.',

  // Account deletion
  'account-deletion': 'Konto Löschen',
  'account-deletion.intro-text':
    'Wenn Sie Ihr Konto löschen, entfernen wir Ihre personenbezogenen Angaben aus dem Patientenportal und deaktivieren den Zugang.\n  In bestimmten Fällen werden Daten nicht vollständig gelöscht, sondern dauerhaft anonymisiert, sodass kein Rückschluss auf Ihre Person mehr möglich ist.',
  'account-deletion.what-we-do': 'Was wir tun',
  'account-deletion.what-we-do.text': 'Bei der Kontolöschung werden wir:',
  'account-deletion.what-we-do.ul1':
    'Ihr Konto deaktivieren, sodass Sie sich nicht mehr anmelden können',
  'account-deletion.what-we-do.ul2':
    'Personenbezogene Daten entfernen, z.B. Name, Geburtsdatum, E-Mail-Adresse, Telefonnummer, Passwort und Profildaten',
  'account-deletion.what-we-do.ul3':
    'Falls erforderlich: Daten anonymisieren, statt sie vollständig zu löschen',
  'account-deletion.anonymization': 'Anonymisierung statt vollständiger Löschung',
  'account-deletion.anonymization.text':
    'In Einzelfällen anonymisieren wir Daten, anstatt sie vollständig zu löschen. Das kann notwendig sein, um',
  'account-deletion.anonymization.ul1': 'gesetzliche Nachweise zu erfüllen,',
  'account-deletion.anonymization.ul2':
    'die technische Konsistenz von Vorgängen (z.B. Termin- oder Dokumentenprozessen) sicherzustellen oder',
  'account-deletion.anonymization.ul3':
    'Sicherheitszwecke und Missbrauchsprävention zu unterstützen',
  'account-deletion.closing-text':
    'Dabei werden alle personenbezogenen Merkmale dauerhaft entfernt, sodass kein Rückschluss auf Ihre Person möglich ist.\n  Die Daten werden anschließend nur noch anonymisiert für statistische oder sicherheitsrelevante Zwecke verwendet.',
  'account-deletion.notice-text': `<strong>Wichtig:</strong> Anonymisierte Daten können nicht wiederhergestellt werden.`,

  'account-deletion.delete-account': 'Konto löschen',
  'account-deletion.delete-account.popconfirm':
    'Sind Sie sicher, dass Sie ihr Konto löschen wollen? Diese Aktion kann nicht rückgangig gemacht werden.',
  'account-deletion.success': 'Ihr Konto wurde erfolgreich gelöscht',
  'account-deletion.modal-title': 'Konto gelöscht',
  'account-deletion.go-to-home-screen': 'Zur Startseite',
  'account-deletion.password-modal.title': 'Sind Sie sicher dass Sie Ihr Konto löschen möchten?',
  'account-deletion.password-modal.description':
    'Bitte geben Sie Ihr Passwort ein, um die Löschung zu bestätigen. Diese Aktion kann nicht rückgängig gemacht werden.',
  'account-deletion.password-modal.secondary-button': 'Abbrechen',
  'account-deletion.generic-error':
    'Etwas ist schiefgelaufen. Bitte überprüfen Sie Ihre Zugangsdaten',
};
